module.exports = __webpack_public_path__ + "static/media/bathtub_icon.8c4f8a8c.svg";